import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Form, FloatingLabel, InputGroup, Button, Dropdown, DropdownButton } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom"
import Layout from "../layout/layout";
import APIHandler from '../../helper/APIHandler';
import { toast } from 'react-toastify';
import moment from 'moment';

const BookingDetails = () => {
    const location = useLocation()
  
    const bookingid = location.state?.bookingid
    const [tab, setTab] = useState('Booking Summary')

    const [Activities, setActivities] = useState({
        prescriptions:[],
        medicalReports:[],
        activityLog:[]
    })
    const { prescriptions,medicalReports,activityLog }=Activities


    const [bookingData, setbookingData] = useState(
        {
            id: bookingid || 0,
            booking_type: "",
            notes: "",
            room_id: "",
            allergy: "",
            past_medical_issue: "",
            on_medication: "",
            remark: "",
            appointment_date: "",
            booking_date: "",
            booked_by: "",
            user_address: "",
            user_email: "",
            service_type: "",
            booked_for: "",
            pickup_address: "",
            is_video_consultancy: "",
            other_name: "",
            other_gender: "",
            other_mobile: "",
            other_age: "",
            short_description: "",
            total_amount: "",
            paid_amount: "",
            reason: "",
            status: "",
            is_active: "",
            provider_id: "",
            provider_name: "",
            provider_email: "",
            provider_mobile: "",
            is_confirmed: "",
            service_provider_address: "",
            profile_pic: "",
            service: "",
            service_provider_user_id: "",
            tran_id: "",
            payment_mode: "",
            experience: "",
            degree: "",
            progress: "",
            slots: [],
            specializations: [],
            medical_history: [],


        }
    )
    const { id,
        booking_type,
        notes,
        room_id,
        allergy,
        past_medical_issue,
        on_medication,
        remark,
        appointment_date,
        booking_date,
        booked_by,
        user_address,
        user_email,
        service_type,
        booked_for,
        pickup_address,
        is_video_consultancy,
        other_name,
        other_gender,
        other_mobile,
        other_age,
        short_description,
        total_amount,
        paid_amount,
        reason,
        status,
        is_active,
        provider_id,
        provider_name,
        provider_email,
        provider_mobile,
        is_confirmed,
        service_provider_address,
        profile_pic,
        service,
        service_provider_user_id,
        tran_id,
        payment_mode,
        experience,
        degree,
        progress,
        slots,
        specializations,
        medical_history } = bookingData;




    useEffect(() => {
       
        searchData(id)
        ActivityData(id)

    }, [])

    const searchData = async (id) => {
        var result = await APIHandler.get(`bookings/${bookingid}`)      
        setbookingData(result.data);
    }

    // Activity
    const ActivityData = async (id) => {
        var result = await APIHandler.get(`users/bookings/${bookingid}/activities`)      
        setActivities(result.data);
        console.log("Activities",result.data)

    }

// const UpdateAcknowledge = async (e, status) => {

//     console.log("Acknowledge call");
//         // var result = await APIHandler.patch(`bookings/changebookingconfirmstatus/${id}?status=${status}`)
//         var result = await APIHandler.patch(`bookings/changebookingconfirmstatus/724?status=true`)
//         console.log(" when click on achnowledge status",result)      
//         if (result != undefined) {
//             if (result.success) {
//                 if (result.data.is_confirmed) {
//                     toast.success("User successfully approved")
//                 }
//                 else {
//                     toast.success("User successfully rejected")
//                 }
//             }
//         }
    //    <Link to="" state={{period:periodvar,status:statusvar}}

    //    const location=useLocation()

    //    s=location.state.period

    

    return (
        <>
            <Layout />

            <div className="content-wrapper my_wrapper">
                <div className="content-header">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Booking ID : {bookingid}</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <Link to="/bookings"><i className="bi bi-chevron-compact-left"></i> Back to Booking</Link>
                            </ol>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="row mt-2">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header d-flex p-0">
                                    <ul className="nav nav-pills p-2">
                                        <li className="nav-item"><a className="nav-link active" href="#tab_1" data-toggle="tab">Booking Summary </a></li>
                                        <li className="nav-item"><a className="nav-link" href="#tab_2" data-toggle="tab">Activities</a></li>
                                    </ul>
                                </div>
                                <div className="card-body">
                                    <div className="tab-content">
                                        <div className="tab-pane active" id="tab_1">
                                            <Row className="mb-3">
                                                <Form.Group as={Col} controlId="Summary">
                                                    <Form.Label>Service</Form.Label>
                                                    <Form.Control name="service" value={service} />
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="Summary">
                                                    <Form.Label>Status</Form.Label>
                                                    <Form.Control name="status" value={status} />
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="Summary">
                                                    <Form.Label>Booking Date & Time</Form.Label>
                                                    <Form.Control name="bookingdate" value= {moment(booking_date).format("YYYY/MM/DD hh:mm A")} />
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="Summary">
                                                    <Form.Label>Appointment/Schedule Date</Form.Label>
                                                    <Form.Control name="appointment" value={moment(appointment_date).format("YYYY/MM/DD hh:mm A")}  />
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="Summary">
                                                    <Form.Label>Fee Paid</Form.Label>
                                                    <Form.Control name="feepaid" value={total_amount} />
                                                </Form.Group>

                                            </Row>
                                            <h5 className='bd_title'>Service Provider</h5>
                                            <div className="booking-box">

                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formGridCity" className='col-4'>
                                                        <Form.Label>Name </Form.Label>
                                                        <Form.Control name="providername" value={provider_name} />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formGridState" className='col-8'>
                                                        <Form.Label>Address</Form.Label>
                                                        <Form.Control name="provideraddress" value={service_provider_address} />
                                                    </Form.Group>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Form.Group as={Col} controlId="formGridCity">
                                                        <Form.Label>Specialization</Form.Label>
                                                        <Form.Control name="specialization" />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formGridState">
                                                        <Form.Label>Email</Form.Label>
                                                        <Form.Control name="provideremail" value={provider_email} />
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridState">
                                                        <Form.Label>Mobile</Form.Label>
                                                        <Form.Control name="providermobile" value={provider_mobile} />
                                                    </Form.Group>

                                                </Row>
                                            </div>

                                            <h5 className='bd_title'>User Details</h5>
                                            <div className="booking-box">
                                                <Row className="mb-3">

                                                    <Form.Group as={Col} controlId="formGridCity" className='col-4'>
                                                        <Form.Label>Name </Form.Label>
                                                        <Form.Control name="username" value={booked_by} />
                                                    </Form.Group>

                                                    <Form.Group as={Col} controlId="formGridState" className='col-8'>
                                                        <Form.Label>Address</Form.Label>
                                                        <Form.Control name="useraddress" value={user_address} />
                                                    </Form.Group>

                                                </Row>
                                                <Row className="mb-3">

                                                    <Form.Group as={Col} controlId="formGridState">
                                                        <Form.Label>Email</Form.Label>
                                                        <Form.Control name="useremail" value={user_email} />
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridState">
                                                        <Form.Label>Mobile</Form.Label>
                                                        <Form.Control name="usermobile" value={other_mobile} />
                                                    </Form.Group>

                                                </Row>
                                                <Row className="mb-3">

                                                    <Form.Group as={Col} controlId="formGridState">
                                                        <Form.Label>Booked For</Form.Label>
                                                        <Form.Control name="email" value={booked_for} />
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridState">
                                                        <Form.Label>Name</Form.Label>
                                                        <Form.Control name="bookedfor" value={other_name} />
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="formGridState">
                                                        <Form.Label>Age</Form.Label>
                                                        <Form.Control name="age" value={other_age} />
                                                    </Form.Group>

                                                </Row>
                                                <Row className="mb-3">

                                                    <Form.Group as={Col} controlId="formGridState">
                                                        <Form.Label>Medical History (If Any)</Form.Label>
                                                        <Form.Control as="textarea" rows={2} name="medicalhistory" />
                                                    </Form.Group>

                                                </Row>
                                                <Row className="mb-3">

                                                    <Form.Group as={Col} controlId="formGridState">
                                                        <Form.Label>Note (If Any)</Form.Label>
                                                        <Form.Control as="textarea" rows={2} name="note" value={notes} />
                                                    </Form.Group>

                                                </Row>
                                            </div>

                                            <div className="acknowledge">
                                                <Row className="">
                                                    <Form.Group as={Col} controlId="formGridState">
                                                        <button className="btn btn-primary">Acknowledge </button> &nbsp;
                                                        <button className="btn btn-danger">Cancel </button>
                                                    </Form.Group>

                                                </Row>
                                            </div>



                                        </div>

                                        <div className="tab-pane" id="tab_2">

                                            <div className='row user-action-box'>
                                                <div className="col-12">
                                                    <h5 className='bd_title'>E-Prescriptions</h5>
                                                    <div className="">
                                                        <div className="">
                                                            <table className="table table-striped  table-bordered " >
                                                                <thead>
                                                                    <tr>
                                                                        <th>
                                                                            Title
                                                                        </th>
                                                                        <th>
                                                                            Uploaded On
                                                                        </th>
                                                                        <th>
                                                                            View
                                                                        </th>
                                                                        <th>
                                                                            Download
                                                                        </th>

                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                {prescriptions.map(obj => (
                                                                        <tr>
                                                                            <td>{obj.complaints}</td>
                                                                            <td>{obj.created_at}</td>                                                                           
                                                                            <td><a href={obj.prescription} target="_blank">View</a> </td>
                                                                            <td><a href={obj.attachment} target="_blank">Download</a> </td>
                                                                          

                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <h5 className='bd_title'>Reports</h5>
                                                    <div className="">
                                                        <div className="">
                                                            <table className="table table-striped  table-bordered " >
                                                                <thead>

                                                                    <tr>
                                                                        <th>
                                                                            Title
                                                                        </th>
                                                                        <th>
                                                                            Uploaded On
                                                                        </th>
                                                                        <th>
                                                                            View
                                                                        </th>
                                                                        <th>
                                                                            Download
                                                                        </th>

                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                {medicalReports.map(obj => (
                                                                        <tr>
                                                                            <td>{obj.report_name}</td>
                                                                            <td>{obj.report_date}</td>                                                                           
                                                                            <td><a href={obj.attachment} target="_blank">View</a> </td>
                                                                            <td><a href={obj.attachment} target="_blank">Download</a> </td>
                                                                          

                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <h5 className='bd_title'>Activity Logs</h5>
                                                    <div className="">
                                                        <div className="">
                                                            <table className="table table-striped  table-bordered " >
                                                                <thead>
                                                                    <tr>
                                                                        <th>
                                                                            Title
                                                                        </th>
                                                                        <th>
                                                                            Performed By
                                                                        </th>
                                                                        <th>
                                                                            Log Date Time
                                                                        </th>


                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                {activityLog.map(obj => (
                                                                        <tr>
                                                                            <td>{obj.title}</td>
                                                                            <td>{obj.performed_by}</td> 
                                                                            <td>{obj.log_date_time}</td>                                                                          
                                                                            
                                                                            

                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>



                                        </div>



                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>




                </section>





            </div>
        </>
    )
}
export default BookingDetails 